module.exports = __webpack_public_path__ + "static/img/nine3.1eb8f9e6.jpg";